export const slidingScreenshotAccent = "#3BA666";

export const promoNavy = "#0f172a";
export const promoSubtitle = "#64748b";
export const promoPillText = "#334155";

export const phoneShellSx = {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 38%, #eef2f7 100%)",
    color: promoNavy,
    pt: "max(env(safe-area-inset-top, 0px), 44px)",
    pb: "env(safe-area-inset-bottom, 0px)",
};

/** Shot 1 — clean full-bleed gradient (no empty letterbox). */
export const classicShellSx = {
    ...phoneShellSx,
    background:
        "radial-gradient(ellipse at 50% 0%, rgba(59,166,102,0.18) 0%, transparent 55%), linear-gradient(165deg, #0f172a 0%, #134e4a 42%, #1e293b 78%, #0f172a 100%)",
    color: "#f8fafc",
    pt: "max(env(safe-area-inset-top, 0px), 36px)",
    pb: "max(env(safe-area-inset-bottom, 0px), 16px)",
    overflow: "hidden",
};

/** Shot 4 — deep teal gradient, expert 6×6 panel. */
export const giantShellSx = {
    ...phoneShellSx,
    backgroundColor: "#042f2e",
    backgroundImage: `
        radial-gradient(ellipse at 50% 0%, rgba(45,212,191,0.28) 0%, transparent 52%),
        linear-gradient(180deg, #134e4a 0%, #0f766e 32%, #115e59 68%, #042f2e 100%)
    `,
    color: "#f8fafc",
    pt: "max(env(safe-area-inset-top, 0px), 36px)",
    pb: "max(env(safe-area-inset-bottom, 0px), 16px)",
    overflow: "hidden",
};

/** Shot 7 — rich midnight teal fill to frame edges. */
export const mexicoShellSx = {
    ...phoneShellSx,
    background: "#022c22",
    color: "#f8fafc",
    pt: 0,
    pb: 0,
    height: "100dvh",
    minHeight: "100dvh",
    maxHeight: "100dvh",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
};

/** Shot 5 — in-app play (board + reference tray) on the night play background. */
export const playBoardShellSx = {
    ...phoneShellSx,
    background: "#0f172a",
    color: "#f8fafc",
    pt: "max(env(safe-area-inset-top, 0px), 12px)",
    pb: "max(env(safe-area-inset-bottom, 0px), 12px)",
    height: "100%",
    minHeight: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    position: "relative",
};

/** Shot 5 — soft ambient collection glow. */
export const themesShellSx = {
    ...phoneShellSx,
    background:
        "radial-gradient(ellipse at 50% 20%, rgba(255,255,255,0.55) 0%, transparent 50%), radial-gradient(circle at 12% 70%, rgba(59,166,102,0.2), transparent 42%), radial-gradient(circle at 90% 30%, rgba(14,165,233,0.16), transparent 40%), linear-gradient(180deg, #ecfdf5 0%, #f0f9ff 45%, #e2e8f0 100%)",
    color: promoNavy,
    pt: "max(env(safe-area-inset-top, 0px), 36px)",
    pb: "max(env(safe-area-inset-bottom, 0px), 12px)",
    overflow: "hidden",
    position: "relative",
};

export const promoSystemFont = "inherit";

export const promoHeaderSx = {
    flexShrink: 0,
    px: 2,
    pt: 1.5,
    pb: 1.5,
    textAlign: "center",
};

export const promoHeaderLightSx = {
    ...promoHeaderSx,
    pt: 1,
    pb: 1.25,
};

export const galleryPhoneShellSx = {
    ...phoneShellSx,
    background: "#ffffff",
    pt: 0,
    pb: 0,
    minHeight: "100dvh",
    height: "100dvh",
    maxHeight: "100dvh",
    overflow: "hidden",
};

export const galleryHeaderSx = {
    flexShrink: 0,
    px: 2,
    pt: "max(calc(env(safe-area-inset-top, 0px) + 12px), 56px)",
    pb: 2,
    textAlign: "center",
    background: "linear-gradient(135deg, #0f172a 0%, #134e4a 38%, #3BA666 92%)",
    boxShadow: "0 6px 28px rgba(15, 23, 42, 0.14)",
};

export const galleryHeaderAmbientSx = {
    ...galleryHeaderSx,
    background: "transparent",
    boxShadow: "none",
    pt: "max(calc(env(safe-area-inset-top, 0px) + 8px), 40px)",
    pb: 1.5,
};

export const galleryHeadlineSx = {
    fontFamily: promoSystemFont,
    fontWeight: 800,
    fontSize: { xs: "2rem", sm: "2.25rem" },
    lineHeight: 1.2,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#ffffff",
    m: 0,
    textShadow: "0 2px 16px rgba(0, 0, 0, 0.22)",
};

export const galleryHeadlineDarkSx = {
    ...galleryHeadlineSx,
    textTransform: "none",
    letterSpacing: "-0.02em",
    fontSize: { xs: "1.65rem", sm: "1.85rem" },
    color: promoNavy,
    textShadow: "none",
};

/** Headline + subtitle stack above the board (App Store screenshots). */
export const promoHeadlineStackSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.75,
    maxWidth: 340,
    mx: "auto",
};

export const promoHeadlineSx = {
    fontFamily: promoSystemFont,
    fontWeight: 700,
    fontSize: { xs: "2rem", sm: "2.25rem" },
    lineHeight: 1.25,
    letterSpacing: "-0.01em",
    color: promoNavy,
    m: 0,
};

export const promoHeadlineLightSx = {
    ...promoHeadlineSx,
    fontWeight: 800,
    fontSize: { xs: "1.75rem", sm: "2rem" },
    letterSpacing: "-0.02em",
    color: "#f8fafc",
    textShadow: "0 2px 18px rgba(2,6,23,0.45)",
};

export const promoHeadlineStackGiantSx = {
    ...promoHeadlineStackSx,
    maxWidth: 420,
    gap: 1,
};

export const promoHeadlineGiantSx = {
    ...promoHeadlineLightSx,
    fontWeight: 900,
    fontSize: { xs: "1.85rem", sm: "2.2rem" },
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    lineHeight: 1.12,
};

export const promoHeadlineSubtitleSx = {
    fontFamily: promoSystemFont,
    fontWeight: 400,
    fontSize: { xs: "1rem", sm: "1.08rem" },
    lineHeight: 1.5,
    letterSpacing: "0.005em",
    color: promoSubtitle,
    m: 0,
};

export const promoHeadlineSubtitleLightSx = {
    ...promoHeadlineSubtitleSx,
    color: "rgba(226,232,240,0.88)",
};

/** @deprecated Legacy single-line all-caps title — prefer promoHeadlineSx. */
export const promoTitleSx = {
    ...promoHeadlineSx,
    fontWeight: 800,
    fontSize: { xs: "2.1rem", sm: "2.35rem" },
    letterSpacing: "0.03em",
    textTransform: "uppercase",
};

export const promoSubtitleSx = {
    fontSize: { xs: "1.25rem", sm: "1.35rem" },
    fontWeight: 600,
    color: promoSubtitle,
    letterSpacing: "0.01em",
};

export const puzzleTitleBarSx = {
    flexShrink: 0,
    px: 2,
    pt: 1.5,
    pb: 1.5,
    textAlign: "center",
};

export const puzzleTagRowSx = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 0.75,
    mt: 1,
};

export const featurePillsRowSx = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    mt: 1.75,
};

export const featurePillSx = {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    px: 1.35,
    py: 0.55,
    borderRadius: 999,
    bgcolor: "rgba(255,255,255,0.92)",
    border: "1px solid rgba(148,163,184,0.32)",
    boxShadow: "0 1px 4px rgba(15,23,42,0.06)",
    fontSize: "0.72rem",
    fontWeight: 600,
    fontFamily: promoSystemFont,
    color: promoPillText,
    whiteSpace: "nowrap",
};

export const boardRegionSx = {
    flexShrink: 0,
    width: "100%",
    boxSizing: "border-box",
};

export const boardRegionFramedSx = {
    ...boardRegionSx,
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: { xs: 1.5, sm: 2 },
    py: { xs: 1, sm: 1.5 },
};

export const boardRegionBleedSx = {
    flex: 1,
    minHeight: 0,
    width: "100%",
    display: "flex",
    overflow: "hidden",
};

export const boardFrameSx = {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    borderRadius: 0,
    boxShadow: "0 8px 32px rgba(15, 23, 42, 0.12)",
};

/**
 * Phone chrome around framed marketing shots (01 / 04 / 07).
 * Full-width board on all sizes (tablet App Store screenshots).
 */
export const phoneDeviceFrameSx = {
    width: "100%",
    maxWidth: "100%",
    borderRadius: { xs: "28px", md: "36px" },
    p: { xs: "7px", md: "10px" },
    background:
        "linear-gradient(160deg, rgba(226,232,240,0.75) 0%, rgba(15,23,42,0.95) 48%, rgba(56,189,248,0.28) 100%)",
    boxShadow:
        "0 24px 48px rgba(0,0,0,0.35), 0 0 0 1px rgba(186,230,253,0.22)",
    boxSizing: "border-box",
};

export const phoneDeviceScreenSx = {
    borderRadius: { xs: "22px", md: "28px" },
    overflow: "hidden",
    bgcolor: "#0f172a",
    boxShadow: "inset 0 0 0 1px rgba(15,23,42,0.35)",
};

export const galleryTopRowSx = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "2px",
    width: "100%",
    minHeight: 0,
    bgcolor: "#ffffff",
};

export const galleryGridRegionSx = {
    flex: 1,
    minHeight: 0,
    width: "100%",
    px: 0,
    pb: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    bgcolor: "#ffffff",
    overflow: "hidden",
};

export const galleryGridRegionFramedSx = {
    ...galleryGridRegionSx,
    width: "auto",
    alignSelf: "stretch",
    mx: 1.5,
    mb: 1.5,
    borderRadius: "22px",
    overflow: "hidden",
    boxShadow: "0 18px 40px rgba(15,23,42,0.18)",
    border: "1.5px solid rgba(15, 23, 42, 0.22)",
};

export const galleryGridSx = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "2px",
    width: "100%",
    minHeight: 0,
    bgcolor: "#ffffff",
};

export const galleryCellSx = {
    minWidth: 0,
    minHeight: 0,
    height: "100%",
};

export const galleryCellFrameSx = {
    width: "100%",
    height: "100%",
    overflow: "hidden",
};

export const galleryImageSx = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
};

export const screenshotMetaRegionSx = {
    flex: 1,
    flexShrink: 0,
    minHeight: 100,
    mt: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: 2,
    py: 2,
    background: "linear-gradient(180deg, rgba(248,250,252,0) 0%, rgba(241,245,249,0.85) 35%, #eef2f7 100%)",
};

export const screenshotMetaRegionOverlaySx = {
    ...screenshotMetaRegionSx,
    flex: "0 0 auto",
    minHeight: 88,
    background: "transparent",
};

export const screenshotMetaShellSx = {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    borderRadius: 999,
    overflow: "hidden",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: "1px solid rgba(148,163,184,0.28)",
    boxShadow: "0 4px 20px rgba(15,23,42,0.08), inset 0 1px 0 rgba(255,255,255,0.9)",
};

export const screenshotMetaShellOnDarkSx = {
    ...screenshotMetaShellSx,
    background: "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.92) 100%)",
    boxShadow: "0 8px 28px rgba(0,0,0,0.28)",
};

export const screenshotMetaHalfSx = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.25,
    py: 1.75,
    px: 2,
    minWidth: 0,
};

export const screenshotMetaDividerSx = {
    width: "1px",
    alignSelf: "stretch",
    my: 1.25,
    bgcolor: "rgba(148,163,184,0.35)",
    flexShrink: 0,
};

export const screenshotMetaIconSx = {
    fontSize: 26,
    color: "#64748b",
    flexShrink: 0,
};

export const screenshotMetaLabelSx = {
    m: 0,
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: "#94a3b8",
    lineHeight: 1.3,
};

export const screenshotMetaValueSx = {
    m: 0,
    mt: 0.35,
    fontSize: "1.05rem",
    fontWeight: 700,
    color: promoNavy,
    lineHeight: 1.2,
    letterSpacing: "0.01em",
};

/** Shot 03 — Ghost Guide feature (white, spacious; no Pro upgrade strip). */
export const ghostGuideShellSx = {
    ...phoneShellSx,
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 55%, #ffffff 100%)",
    color: promoNavy,
    pt: "max(env(safe-area-inset-top, 0px), 36px)",
    pb: "max(env(safe-area-inset-bottom, 0px), 20px)",
    overflow: "hidden",
};

/**
 * Letterbox / shell fill for Google Ads (must match screenshot page shells).
 * @param {{ marketing?: string, layout?: string }} scene
 */
export function slidingShellBgForScene(scene) {
    if (scene?.theme === "light") {
        return phoneShellSx.background;
    }
    const marketing = scene?.marketing;
    if (marketing === "classic") {
        return classicShellSx.background;
    }
    if (marketing === "giant") {
        return `${giantShellSx.backgroundImage}, ${giantShellSx.backgroundColor || "#042f2e"}`;
    }
    if (marketing === "mexico") {
        return mexicoShellSx.background;
    }
    if (marketing === "themes" || scene?.layout === "twoColumnGrid") {
        return themesShellSx.background;
    }
    if (marketing === "ghostGuide") {
        return ghostGuideShellSx.background;
    }
    if (scene?.layout === "playBoard") {
        return phoneShellSx.background;
    }
    return phoneShellSx.background;
}

export const ghostGuideBoardWrapSx = {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    overflow: "visible",
    borderRadius: 0,
    boxShadow: "0 8px 32px rgba(15, 23, 42, 0.12)",
};

export const ghostGuideOverlayRootSx = {
    position: "absolute",
    inset: 0,
    zIndex: 12,
    pointerEvents: "none",
    overflow: "visible",
};

export const ghostGuidePathLineSx = {
    position: "absolute",
    height: 6,
    borderRadius: 999,
    background:
        "linear-gradient(90deg, rgba(59,166,102,0.15) 0%, rgba(59,166,102,0.95) 45%, rgba(59,166,102,0.2) 100%)",
    boxShadow: "0 0 14px rgba(59,166,102,0.55)",
};

export const ghostGuidePathDotSx = {
    position: "absolute",
    width: 40,
    height: 40,
    display: "block",
    lineHeight: 0,
    zIndex: 10,
    filter: "drop-shadow(0 0 8px rgba(45, 212, 191, 0.75))",
};

/** Callout base — position is set relative to the first hint cell. */
export const ghostGuideCalloutSx = {
    position: "absolute",
    zIndex: 4,
    maxWidth: "42%",
    px: 1.1,
    py: 0.7,
    borderRadius: 2,
    bgcolor: "rgba(255,255,255,0.96)",
    border: "1px solid rgba(59,166,102,0.35)",
    boxShadow: "0 8px 22px rgba(15,23,42,0.14)",
    color: promoNavy,
    fontSize: "0.7rem",
    fontWeight: 700,
    lineHeight: 1.35,
    textAlign: "center",
    pointerEvents: "none",
};

export const ghostGuideRegionSx = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    px: 2,
    pt: 1.5,
    pb: 1,
    minHeight: 0,
    background: "#ffffff",
};

export const ghostGuideCardSx = {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 3,
    bgcolor: "#ffffff",
    border: "1px solid rgba(148,163,184,0.28)",
    boxShadow: "0 4px 20px rgba(15,23,42,0.06)",
    px: 2,
    pt: 1.75,
    pb: 1.75,
};

export const ghostGuideHowToTitleSx = {
    m: 0,
    fontFamily: promoSystemFont,
    fontWeight: 800,
    fontSize: "1.05rem",
    letterSpacing: "0.01em",
    color: promoNavy,
    textAlign: "left",
};

export const ghostGuideStepRowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.1,
};

export const ghostGuideStepNumSx = {
    flexShrink: 0,
    width: 22,
    height: 22,
    borderRadius: "999px",
    bgcolor: slidingScreenshotAccent,
    color: "#fff",
    fontSize: "0.72rem",
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: "1px",
};

export const ghostGuideStepTextSx = {
    m: 0,
    fontFamily: promoSystemFont,
    fontSize: "0.82rem",
    fontWeight: 500,
    lineHeight: 1.4,
    color: promoPillText,
};

export const ghostGuideFreeHintBtnSx = {
    mt: 1.75,
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.75,
    minHeight: 44,
    px: 2,
    py: 1.15,
    borderRadius: 2,
    bgcolor: "#e2e8f0",
    color: promoNavy,
    fontFamily: promoSystemFont,
    fontSize: "0.88rem",
    fontWeight: 700,
    letterSpacing: "0.01em",
    border: "1px solid rgba(148,163,184,0.45)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
};

export const ghostGuideSceneFooterSx = {
    m: 0,
    mt: "auto",
    pt: 3.5,
    pb: 0.5,
    textAlign: "center",
    fontFamily: promoSystemFont,
    fontSize: "0.78rem",
    fontWeight: 600,
    letterSpacing: "0.06em",
    color: "#94a3b8",
};
